var percentage = "https://shopfront-cdn.tekoapis.com/static/fc6f3b4f8e2c8800.svg";

export { percentage as default };
